var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-code",attrs:{"src":_vm.imgSrc},on:{"click":_vm.init}})
}
var staticRenderFns = []

export { render, staticRenderFns }